import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import WP from 'WP';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Tooltip from 'partials/Tooltip';

import Slider from 'icons/SlidersIcon';
import Clock from 'icons/ClockIcon';
import User from 'icons/UserIcon';
import Triangle from 'icons/TriangleIcon';

import Media from 'css/Media';

export class ActivityFactBox extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTooltip: null,
        }
    }


    toggleTooltip = (index) => {
        this.setState({
            activeTooltip: this.state.activeTooltip === index ? null : index
        })
    }

    render() {
        const { data, last } = this.props;
        const { activeTooltip } = this.state;

        return (
            <ModuleWrapper last={last}>
                <Container grid mobileBleed>
                    <StyledGridElement
                        colStart={{default: 1, s: 7}}
                        colEnd={{default: 8, s: 18}}
                    >
                    <InnerContainer>
                        <GridElement
                            colStart={{default: 2, s: 2}}
                            colEnd={{default: 7, s: 10}}
                            rowStart={1}
                            colSpan
                        >
                            <h3>{data.title}</h3>
                        </GridElement>
                            <StyledInnerGridElement
                                colStart={{default: 2, s: 2}}
                                colEnd={{default: 7, s: 10}}
                                rowStart={2}
                                colSpan
                            >
                                <Slider />
                                <p>{WP.trans.difficulty}{data.difficulty}</p>
                                { data.difficulty_tooltip &&
                                    <TooltipWrapper onClick={() => this.toggleTooltip(0)}>
                                        <p>?</p>
                                        <Tooltip idx={0} active={activeTooltip} data={data.difficulty_tooltip} />
                                    </TooltipWrapper>
                                }
                            </StyledInnerGridElement>
                            <StyledInnerGridElement
                                colStart={{default: 2, s: 2}}
                                colEnd={{default: 7, s: 10}}
                                rowStart={3}
                                colSpan
                                repeater
                            >
                                <Clock />
                                {data.time_slots.map((time_slot, idx) => {
                                    return (
                                        <p key={idx}>{time_slot.starting_time} - {time_slot.end_time}</p>
                                    )
                                })}
                                { data.starting_time_tooltip &&
                                    <TooltipWrapper onClick={() => this.toggleTooltip(1)}>
                                        <p>?</p>
                                        <Tooltip idx={1} active={activeTooltip} data={data.starting_time_tooltip} />
                                    </TooltipWrapper>
                                }
                            </StyledInnerGridElement>
                            <StyledInnerGridElement
                                colStart={{default: 2, s: 2}}
                                colEnd={{default: 7, s: 10}}
                                rowStart={4}
                                colSpan
                            >
                                <User />
                                <p>{WP.trans.minParticipants}{data.min_people}</p>
                                { data.min_people_tooltip &&
                                    <TooltipWrapper onClick={() => this.toggleTooltip(2)}>
                                        <p>?</p>
                                        <Tooltip idx={2} active={activeTooltip} data={data.min_people_tooltip} />
                                    </TooltipWrapper>
                                }
                            </StyledInnerGridElement>
                            <StyledInnerGridElement
                                colStart={{default: 2, s: 2}}
                                colEnd={{default: 7, s: 10}}
                                rowStart={5}
                                colSpan
                            >
                                <Triangle />
                                <p>{WP.trans.ageLimit} {data.age_limit > 0 ? data.age_limit + WP.trans.years : WP.trans.noAgeLimit}</p>
                                { data.age_limit_tooltip &&
                                    <TooltipWrapper onClick={() => this.toggleTooltip(3)}>
                                        <p>?</p>
                                        <Tooltip idx={3} active={activeTooltip} data={data.age_limit_tooltip}/>
                                    </TooltipWrapper>
                                }
                            </StyledInnerGridElement>
                    </InnerContainer>
                    </StyledGridElement>
                </Container>
            </ModuleWrapper>
        )
    }
}

export default ActivityFactBox;

const ModuleWrapper = styled.section`
    .container {
        margin: ${props => props.last ? `${props.theme.spacing.elementM} 0 0` : `${props.theme.spacing.elementM} 0`};

        ${Media.greaterThan('s')`
            margin: ${props => props.last ? `${props.theme.spacing.blockM} 0 0` :`${props.theme.spacing.blockM} 0 ${props.theme.spacing.blockL}`};
        `}

        ${Media.greaterThan('l')`
            margin: ${props => props.last ? `${props.theme.spacing.blockM} auto 0` : `${props.theme.spacing.blockM} auto ${props => props.theme.spacing.blockL}`};
        `}
    }
`

const StyledGridElement = styled(GridElement)`
    background: ${props => props.theme.colors.bg};

    padding: ${props => props.theme.spacing.elementXS} 0 ${props => props.theme.spacing.elementM};

    ${Media.greaterThan('s')`
        padding: ${props => props.theme.spacing.elementM} 0 ${props => props.theme.spacing.elementXL};
    `}
`

const InnerContainer = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 25px (1fr .33fr)[3] 1fr 25px;
    grid-template-columns: 25px repeat(3, 1fr .33fr) 1fr 25px;
    -ms-grid-rows: (auto)[6];
    grid-template-rows: repeat(6, auto);

    h3 {
        padding-bottom: ${props => props.theme.spacing.contentL};
        ${props => props.theme.fonts.h4}
    }
    
    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .435fr)[5] 1fr;
        grid-template-columns: repeat(5, 1fr .435fr) 1fr;

        h3 {
            padding-bottom: ${props => props.theme.spacing.elementS};
            ${props => props.theme.fonts.h3}
        }
    `}
`

const StyledInnerGridElement = styled(GridElement)`
    display: flex;
    align-items: center;
    margin-bottom: ${props => props.theme.spacing.contentS};

    p {
        white-space: nowrap;
    }

    svg {
        margin-right: ${props => props.theme.spacing.contentM};
    }

    ${Media.lessThan('s')`
        p {
            font-size: 14px;
        }
    `}

    ${props => props.repeater && css`
        p {
            &:not(:last-of-type) {
                &::after {
                    position: relative;
                    content: ",";
                    margin-right: 4px;
                }
            }
        }
    `}
`

const TooltipWrapper = styled.div`
    margin-left: ${props => props.theme.spacing.contentS};
    position: relative;
    
    > p {
        text-decoration: underline;
        cursor: pointer;
        color: ${props => props.theme.colors.link};
        user-select: none;
    }
`